// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownSelector_wrapper__YJ9sG","button":"DropdownSelector_button__AIinX","list":"DropdownSelector_list__lrIOA"};